import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-def007ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Numar Document")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Data Document")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Valoare")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Moneda")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Data Scadenta")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Rest de Achitat")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Zile Depasire Termen Plata")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ItemNo:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Description:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ItemNo:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Description:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'my_card_2' : 'card_3')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, { class: "row items-center" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
            }, "Factura " + _toDisplayString(_ctx.invoice.id), 3),
            _createVNode(_component_q_space),
            _withDirectives(_createVNode(_component_q_btn, {
              icon: "close",
              flat: "",
              round: "",
              dense: ""
            }, null, 512), [
              [_directive_close_popup]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_list, { dense: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoice.id), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoice.data), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoice.valoare), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoice.moneda), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoice.dataScadenta), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoice.restDeAchitat), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoice.nrZileDepasireTermenPlata), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, { class: "row items-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              flat: "",
              color: "primary",
              "no-caps": "",
              label: "Factura",
              icon: "picture_as_pdf",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.download_invoice($props.bill_nr)))
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              color: "primary",
              "no-caps": "",
              label: "Certificate",
              icon: "picture_as_pdf",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.download_certificate($props.bill_nr)))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.fixed,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fixed) = $event)),
      "full-width": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      "no-caps": "",
                      color: "primary",
                      onClick: $options.downloadPDF,
                      icon: "download",
                      style: {"margin-left":"1rem","cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      "no-caps": "",
                      flat: "",
                      color: "primary",
                      icon: "download",
                      onClick: $options.downloadPDF,
                      style: {"cursor":"pointer"}
                    }, null, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                _createVNode(_component_q_space),
                (_ctx.isLoadingInvoice)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 2,
                      color: "black",
                      size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                    }, null, 8, ["size"]))
                  : _createCommentVNode("", true),
                (_ctx.isLoadingInvoice)
                  ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: ""
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 5,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.widthPdf=300))
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
              ]),
              _: 1
            }),
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isLoadingInvoice)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.changeWitdhPdf('in'))),
                          icon: "zoom_in",
                          style: {"margin-bottom":"8px"},
                          loading: _ctx.clicked
                        }, null, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoadingInvoice)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.changeWitdhPdf('out'))),
                          icon: "zoom_out",
                          style: {"margin-left":"10px","margin-bottom":"8px"},
                          loading: _ctx.clicked
                        }, null, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    _hoisted_9,
                    _createVNode(_component_vue_pdf_embed, {
                      source: _ctx.pdfBase64,
                      width: _ctx.widthPdf
                    }, null, 8, ["source", "width"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vue_pdf_embed, { source: _ctx.pdfBase64 }, null, 8, ["source"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.areMoreCertificates,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.areMoreCertificates) = $event)),
      "full-width": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card_5" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, "Certificate Factura " + _toDisplayString(_ctx.selectedBillNr), 3),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (certificat, index) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: certificat.ItemNo
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createBlock(_component_q_card, {
                                key: 0,
                                class: "my_card_4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _hoisted_10
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(certificat.ItemNo), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _hoisted_11,
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _hoisted_12
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(certificat.Description), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_actions, { vertical: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        color: "primary",
                                        icon: "picture_as_pdf",
                                        onClick: ($event: any) => ($options.download_certificate_2(index))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 1,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_13,
                                      _createTextVNode(" " + _toDisplayString(certificat.ItemNo), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_14,
                                      _createTextVNode(" " + _toDisplayString(certificat.Description), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 3,
                                class: "pdf_icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    color: "primary",
                                    icon: "picture_as_pdf",
                                    onClick: ($event: any) => ($options.download_certificate_2(index))
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}